/**
 * Positions of Annotations are defined in Annotations.scss
 */
export default[

    {
        type : "annotation",
        position : "center-top",
        time : 83,
        showTime : 3,
        title : "Observatietoren"
    }, {
        type : "annotation",
        position : "center-center",
        time : 117,
        showTime : 3,
        title : "Checkpoint"
    }, {
        type : "annotation",
        position : "center-center",
        time : 146,
        showTime : 4,
        title : "Meitar checkpoint, begin van de Westelijke Jordaanoever"
    }, {
        type : "annotation",
        position : "center-right",
        time : 163,
        showTime : 3,
        title : "Observatietoren"
    }, {
        type : "annotation",
        position : "center-left",
        time : 171,
        showTime : 4,
        title : "Begin van de bezette Westelijke Jordaanoever / gebied C"
    }, {
        type : "annotation",
        position : "center-right",
        time : 177,
        showTime : 3,
        title : "Afscheidingsmuur"
    }, {
        type : "annotation",
        position : "center-right",
        time : 188,
        showTime : 3,
        title : "Groene Lijn"
    }, {
        type : "annotation",
        position : "center-right",
        time : 211,
        showTime : 4,
        title : "Militaire weg langs afscheidingsmuur"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 224,
        showTime : 2,
        title : "Afslag naar de nederzetting Carmel"
    }, {
        type : "annotation",
        position : "center-center",
        time : 235,
        showTime : 3,
        title : "Militaire kilometermarkering aan beide kanten van de weg"
    }, {
        type : "annotation",
        position : "center-right",
        time : 252,
        showTime : 4,
        title : "Nederzetting Shim’a"
    }, {
        type : "annotation",
        position : "top-right",
        time : 266,
        showTime : 16,
        title : "De buitenpost Mitzpe Eshtamoa "
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 294,
        showTime : 12,
        title : "Earthmound"
    }, {
        type : "annotation",
        position : "top-left",
        time : 380,
        showTime : 18,
        title : "Nederzetting Otniel"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 404,
        showTime : 2,
        title : "Kolonist met wapen"
    }, {
        type : "annotation",
        position : "center-top",
        time : 409,
        showTime : 3,
        title : "Wegblokkade, ingang naar gebied A "
    }, {
        type : "annotation",
        position : "center-right",
        time : 418,
        showTime : 10,
        title : "Wegblokkade, ingang naar gebied A"
    }, {
        type : "annotation",
        position : "center-left",
        time : 434,
        showTime : 10,
        title : "Legerbasis"
    }, {
        type : "annotation",
        position : "center-right",
        time : 459,
        showTime : 5,
        title : "Ingang naar gebied A bij het Palestijnse dorp Al Hijra"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 469,
        showTime : 3,
        title : "Earthmound"
    }, {
        type : "annotation",
        position : "center-center",
        time : 483,
        showTime : 3,
        title : "Al Fawwar checkpoint"
    }, {
        type : "annotation",
        position : "center-right",
        time : 487,
        showTime : 3,
        title : "Ribbels tegen explosieven en snelheid"
    }, {
        type : "annotation",
        position : "center-right",
        time : 493,
        showTime : 2,
        title : "Observatietoren"
    }, {
        type : "annotation",
        position : "center-right",
        time : 501,
        showTime : 5,
        title : "Al Fawwar vluchtelingenkamp"
    }, {
        type : "annotation",
        position : "center-top",
        time : 509,
        showTime : 2,
        title : "Ingang naar gebied A"
    }, {
        type : "annotation",
        position : "center-center",
        time : 513,
        showTime : 2,
        title : "Militaire controle bij tijdelijk checkpoint"
    }, {
        type : "annotation",
        position : "center-top",
        time : 518,
        showTime : 6,
        title : "Al Fawwar vluchtelingenkamp"
    }, {
        type : "annotation",
        position : "bottom-left",
        time : 535,
        showTime : 2,
        title : "Legerjeep"
    }, {
        type : "annotation",
        position : "bottom-left",
        time : 539,
        showTime : 4,
        title : "Hier rechtdoor gaat de voormalige route 60 Hebron in"
    }, {
        type : "annotation",
        position : "center-top",
        time : 546,
        showTime : 3,
        title : "Nederzetting Haggai"
    }, {
        type : "annotation",
        position : "center-center",
        time : 551,
        showTime : 2,
        title : "Observatietoren"
    }, {
        type : "annotation",
        position : "center-left",
        time : 554,
        showTime : 2,
        title : "Israëlische politie"
    }, {
        type : "annotation",
        position : "center-left",
        time : 573,
        showTime : 3,
        title : "Ingang naar gebied A met wegversperring"
    }, {
        type : "annotation",
        position : "top-left",
        time : 579,
        showTime : 4,
        title : "Militaire basis"
    }, {
        type : "annotation",
        position : "center-left",
        time : 585,
        showTime : 2,
        title : "Hebron"
    }, {
        type : "annotation",
        position : "center-right",
        time : 589,
        showTime : 3,
        title : "Observatietoren"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 596,
        showTime : 2,
        title : "Ingang naar gebied A met checkpoint"
    }, {
        type : "annotation",
        position : "center-left",
        time : 602,
        showTime : 4,
        title : "Legerbasis"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 609,
        showTime : 3,
        title : "Afslag Grot van de Patriarchen"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 613,
        showTime : 3,
        title : "Ingang naar gebied A, open wegafsluiting"
    }, {
        type : "annotation",
        position : "center-left",
        time : 632,
        showTime : 5,
        title : "Afslag naar nederzetting Kiryat Arba"
    }, {
        type : "annotation",
        position : "top-left",
        time : 638,
        showTime : 20,
        title : "Nederzetting Kiryat Arba"
    }, {
        type : "annotation",
        position : "center-right",
        time : 669,
        showTime : 3,
        title : "Legerjeep"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 675,
        showTime : 3,
        title : "Afslag naar de Palestijnse dorpen Sa’ir en Beit Einun"
    }, {
        type : "annotation",
        position : "center-center",
        time : 680,
        showTime : 5,
        title : " Ras al Joura checkpoint "
    }, {
        type : "annotation",
        position : "center-right",
        time : 686,
        showTime : 2,
        title : "Ingang naar gebied A"
    }, {
        type : "annotation",
        position : "center-left",
        time : 692,
        showTime : 3,
        title : "Observatietoren"
    }, {
        type : "annotation",
        position : "center-left",
        time : 699,
        showTime : 4,
        title : "Hek ter bescherming van stenengooiers"
    }, {
        type : "annotation",
        position : "center-right",
        time : 714,
        showTime : 3,
        title : "Open wegafsluiting naar Al Arrub vluchtelingenkamp"
    }, {
        type : "annotation",
        position : "center-right",
        time : 720,
        showTime : 3,
        title : "Israëlische pantserwagens met observatietoren"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 725,
        showTime : 3,
        title : "Lichte pantserwagens met soldaten"
    }, {
        type : "annotation",
        position : "center-left",
        time : 759,
        showTime : 4,
        title : "Rami Levy supermarkt"
    }, {
        type : "annotation",
        position : "center-center",
        time : 797,
        showTime : 4,
        title : "Gush Etzion checkpoint"
    }, {
        type : "annotation",
        position : "center-left",
        time : 803,
        showTime : 5,
        title : "Beveiligde bushalte"
    }, {
        type : "annotation",
        position : "center-right",
        time : 822,
        showTime : 3,
        title : "Soldaten controleren een Palestijnse auto"
    }, {
        type : "annotation",
        position : "center-top",
        time : 826,
        showTime : 2,
        title : "Militaire toren"
    }, {
        type : "annotation",
        position : "center-left",
        time : 831,
        showTime : 2,
        title : "Soldaten"
    }, {
        type : "annotation",
        position : "center-right",
        time : 837,
        showTime : 4,
        title : "Nederzetting Efrat"
    }, {
        type : "annotation",
        position : "top-right",
        time : 848,
        showTime : 4,
        title : "Bethlehem"
    }, {
        type : "annotation",
        position : "center-right",
        time : 854,
        showTime : 4,
        title : "Afslag naar de voormalige route 60 door Bethlehem"
    }, {
        type : "annotation",
        position : "center-right",
        time : 867,
        showTime : 3,
        title : "Open wegafsluiting met ingang naar gebied A"
    }, {
        type : "annotation",
        position : "center-right",
        time : 872,
        showTime : 3,
        title : "De voormalige route 60 door Bethlehem"
    }, {
        type : "annotation",
        position : "center-left",
        time : 880,
        showTime : 6,
        title : "Afscheidingsmuur"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 890,
        showTime : 4,
        title : "Hierachter liggen de Palestijnse plaatsen Al Khadr en Bethlehem"
    }, {
        type : "annotation",
        position : "top-right",
        time : 896,
        showTime : 2,
        title : "Wegversperring"
    }, {
        type : "annotation",
        position : "top-right",
        time : 902,
        showTime : 3,
        title : "Observatietoren"
    }, {
        type : "annotation",
        position : "center-right",
        time : 910,
        showTime : 2,
        title : "Militaire pantserwagen"
    }, {
        type : "annotation",
        position : "center-right",
        time : 916,
        showTime : 3,
        title : "Afscheidingsmuur"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 922,
        showTime : 3,
        title : "Soldaten"
    }, {
        type : "annotation",
        position : "top-left",
        time : 928,
        showTime : 3,
        title : "Tunnel checkpoint"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 931,
        showTime : 2,
        title : "Ribbels in de weg tegen snelheid en explosieven"
    }, {
        type : "annotation",
        position : "center-top",
        time : 937,
        showTime : 6,
        title : "Vanaf hier mogen auto’s met Palestijnse kentekens niet verder over route 60"
    }, {
        type : "annotation",
        position : "center-top",
        time : 976,
        showTime : 5,
        title : "Tunnels onder het Palestijnse dorp Beit Jala"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 982,
        showTime : 2,
        title : "Afscheidingsmuur aan beide kanten van de weg"
    }, {
        type : "annotation",
        position : "top-left",
        time : 987,
        showTime : 2,
        title : "De nederzetting Gilo"
    }, {
        type : "annotation",
        position : "center-left",
        time : 991,
        showTime : 2,
        title : "Jeruzalem"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1012,
        showTime : 4,
        title : "Dit is weer de voormalige route 60 richting Bethlehem"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1030,
        showTime : 4,
        title : "Afscheidingsmuur met daarachter Bethlehem"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1038,
        showTime : 3,
        title : "Ingang naar het graf van Rachel"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1051,
        showTime : 5,
        title : "Begin van de gemeentegrens van Jeruzalem, volgens Israël"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1138,
        showTime : 3,
        title : "Groene Lijn"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1158,
        showTime : 4,
        title : "De Dormitio-abdij, de plek waar Maria is overleden"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1165,
        showTime : 5,
        title : "Hier achter de berg staat de Klaagmuur en de Al Aqsa Moskee"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1176,
        showTime : 4,
        title : "De muur rond de oude stad, gebouwd door de Ottomanen"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1182,
        showTime : 3,
        title : "Toren van David"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1208,
        showTime : 5,
        title : "De Rotskoepel"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1223,
        showTime : 12,
        title : "De poort naar Damascus"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1254,
        showTime : 6,
        title : "De Groene Lijn"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1277,
        showTime : 2,
        title : "De Groene Lijn"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1280,
        showTime : 2,
        title : "Oost-Jeruzalem"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1283,
        showTime : 2,
        title : "West-Jeruzalem"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1315,
        showTime : 4,
        title : "Joodse wijk French Hill"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1325,
        showTime : 2,
        title : "Shuafat vluchtelingenkamp"
    }, {
        type : "annotation",
        position : "top-left",
        time : 1333,
        showTime : 3,
        title : "De Palestijnse wijk Beit Hanina"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1348,
        showTime : 5,
        title : "Kolonistenbus"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1376,
        showTime : 2,
        title : "De nederzetting Pisgat Ze’ev"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1381,
        showTime : 5,
        title : "Al Ram"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1392,
        showTime : 6,
        title : "Afscheidingsmuur met daarachter het Palestijnse dorp Al Ram"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1423,
        showTime : 4,
        title : "Qalandia checkpoint"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1431,
        showTime : 4,
        title : "Route 60 gaat gebied A in"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1438,
        showTime : 6,
        title : "Het is verboden voor Israëlische staatsburgers om verder te gaan"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1469,
        showTime : 4,
        title : "Auto’s en mensen onderweg naar Jeruzalem worden gecontroleerd"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1479,
        showTime : 3,
        title : "Afscheidingsmuur"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1511,
        showTime : 3,
        title : "Al Ram"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1516,
        showTime : 6,
        title : "Waarschuwing van routeplanner Waze voor ‘gevaarlijk’ gebied"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1535,
        showTime : 3,
        title : "Al Ram"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1604,
        showTime : 3,
        title : "Jaba checkpoint"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1608,
        showTime : 2,
        title : "Observatietoren"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1612,
        showTime : 4,
        title : "Ribbels in de weg tegen snelheid en explosieven"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1620,
        showTime : 4,
        title : "Nederzetting Psagot"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1633,
        showTime : 5,
        title : "Het Palestijnse dorp Burqa"
    }, {
        type : "annotation",
        position : "top-left",
        time : 1650,
        showTime : 2,
        title : "Burqa"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1680,
        showTime : 3,
        title : "Observatietoren"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1693,
        showTime : 5,
        title : "Nederzetting Ofra"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1698,
        showTime : 5,
        title : "Buitenpost Amona"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1706,
        showTime : 3,
        title : "Hek rond nederzetting Ofra"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1725,
        showTime : 5,
        title : "Toegangshek tot nederzetting Ofra"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1736,
        showTime : 3,
        title : "Bushalte beveiligd door soldaten"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1741,
        showTime : 2,
        title : "Observatietoren"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1747,
        showTime : 4,
        title : "Militaire basis"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1757,
        showTime : 4,
        title : "Nederzetting Shilo"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1761,
        showTime : 4,
        title : "Nederzetting Shilo"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1775,
        showTime : 3,
        title : "Kolonistenbus met daarachter een Palestijnse taxibus"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1786,
        showTime : 4,
        title : "Observatieballon met camera"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1792,
        showTime : 2,
        title : "Nederzetting Rechelim South"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1796,
        showTime : 3,
        title : "Tappuah checkpoint"
    }, {
        type : "annotation",
        position : "top-right",
        time : 1803,
        showTime : 3,
        title : "Militaire toren"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1811,
        showTime : 2,
        title : "Militaire toren"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1818,
        showTime : 2,
        title : "Soldaten bij een bushalte"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1825,
        showTime : 4,
        title : "Het Palestijnse dorp Huwwara "
    }, {
        type : "annotation",
        position : "center-left",
        time : 1832,
        showTime : 2,
        title : "Rotonde gesponsord door USAID"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1853,
        showTime : 2,
        title : "Nederzetting Yitzhar"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1856,
        showTime : 6,
        title : "Militaire basis"
    }, {
        type : "annotation",
        position : "bottom-left",
        time : 1889,
        showTime : 2,
        title : "Militaire kilometermarkering"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1897,
        showTime : 3,
        title : "Militaire wachttoren"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1907,
        showTime : 3,
        title : "Sarra-Jit checkpoint, ingang naar gebied A"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1912,
        showTime : 2,
        title : "Militaire wachttoren"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1916,
        showTime : 2,
        title : "Militaire patrouille"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1919,
        showTime : 1,
        title : "Militair pantservoertuig"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1929,
        showTime : 4,
        title : "Route 60 gaat verder in gebied A"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1935,
        showTime : 4,
        title : "Verboden toegang voor Israëlische staatsburgers"
    }, {
        type : "annotation",
        position : "center-center",
        time : 1943,
        showTime : 3,
        title : "Het Palestijnse dorp Deir Sharaf"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1954,
        showTime : 3,
        title : "Nederzetting Shavei Shomron"
    }, {
        type : "annotation",
        position : "center-left",
        time : 1958,
        showTime : 3,
        title : "Muur rond nederzetting Shavei Shomron"
    }, {
        type : "annotation",
        position : "center-right",
        time : 1963,
        showTime : 2,
        title : "Shavei Shomron checkpoint"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 1968,
        showTime : 1,
        title : "Militaire jeep"
    }, {
        type : "annotation",
        position : "center-top",
        time : 1980,
        showTime : 10,
        title : "De Palestijnse stad Jenin"
    }, {
        type : "annotation",
        position : "center-right",
        time : 2018,
        showTime : 4,
        title : "Palestijnse agent"
    }, {
        type : "annotation",
        position : "center-bottom",
        time : 2033,
        showTime : 5,
        title : "Palestijnse veiligheidstroepen"
    }, {
        type : "annotation",
        position : "bottom-right",
        time : 2046,
        showTime : 2,
        title : "Palestijnse politie"
    }, {
        type : "annotation",
        position : "center-center",
        time : 2084,
        showTime : 4,
        title : "Onderweg naar de grens met Israël"
    }, {
        type : "annotation",
        position : "center-center",
        time : 2117,
        showTime : 6,
        title : "Al Jalama checkpoint"
    }, {
        type : "annotation",
        position : "center-center",
        time : 2130,
        showTime : 12,
        title : "De grens met Israël op de Groene Lijn"
    }
]



// WEBPACK FOOTER //
// ./src/data/nl/timeline-annotations.js